module.exports = __webpack_public_path__ + "img/MapPicsInland.7d8d1cdf.webp";